module.exports = __webpack_public_path__ + "static/img/qrcode.73c901a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qrcode.jpg
// module id = TUKC
// module chunks = 15